module.exports = __webpack_public_path__ + "iPhone_6_7_8.svg?8b718e5e16964a5c619e490533e2e436";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPhone_6_7_8.svg
// module id = 226
// module chunks = 0